export const RUSSIAN_PHONES = [
  {
    phone: '911 403 77 27',
    formatted: '+7 911 403-77-27',
    raw: '+79114037727',
  },
  {
    phone: 9114037727,
    formatted: '+7 911 403-77-27',
    raw: '+79114037727',
  },
  {
    phone: 9114037727.00,
    formatted: '+7 911 403-77-27',
    raw: '+79114037727',
  },
  {
    phone: '8 (950) 112-11-22',
    formatted: '+7 950 112-11-22',
    raw: '+79501121122',
  },
  {
    phone: '8 (800) 770-07-34, 8 862 291 73 72',
    formatted: '+7 862 291-73-72',
    raw: '+78622917372',
  },
  {
    phone: '8 (383) 247-8356',
    formatted: '+7 383 247-83-56',
    raw: '+73832478356',
  },
  {
    phone: '8 (34374) 345-13-93',
    formatted: '+7 374 345-13-93',
    raw: '+73743451393',
  },
  {
    phone: '8 (34258) 2-01-32',
    formatted: '+7 342 582-01-32',
    raw: '+73425820132',
  },
  {
    phone: '8 (3012) 244 - 557',
    formatted: '+7 301 224-45-57',
    raw: '+73012244557',
  },
  {
    phone: '7 (495) 724-06-97',
    formatted: '+7 495 724-06-97',
    raw: '+74957240697',
  },
  {
    phone: '602-603, 609-657',
    formatted: '602-603, 609-657',
    raw: '609657',
  },
  {
    phone: '342 414-88-28',
    formatted: '+7 342 414-88-28',
    raw: '+73424148828',
  },
  {
    phone: '+7 918 147-70-37',
    formatted: '+7 918 147-70-37',
    raw: '+79181477037',
  },
  {
    phone: '+7 (495) 123-47-37',
    formatted: '+7 495 123-47-37',
    raw: '+74951234737',
  },
  {
    phone: '+7 (4812) 77-27-27',
    formatted: '+7 481 277-27-27',
    raw: '+74812772727',
  },
  {
    phone: '+7 (4112) 35–38–13, +7–924–765–40–34',
    formatted: '+7 924 765-40-34',
    raw: '+79247654034',
  },
  {
    phone: '(999) 555-02-04',
    formatted: '+7 999 555-02-04',
    raw: '+79995550204',
  },
  {
    phone: '(999) 442-37-06',
    formatted: '+7 999 442-37-06',
    raw: '+79994423706',
  },
  {
    phone: '(999) 009-33-33',
    formatted: '+7 999 009-33-33',
    raw: '+79990093333',
  },
  {
    phone: '(996) 134-12-34',
    formatted: '+7 996 134-12-34',
    raw: '+79961341234',
  },
  {
    phone: '(995) 115-03-03, (495) 145-95-05',
    formatted: '+7 495 145-95-05',
    raw: '+74951459505',
  },
  {
    phone: '(993) 435-36-37',
    formatted: '+7 993 435-36-37',
    raw: '+79934353637',
  },
  {
    phone: '(991) 715-44-10',
    formatted: '+7 991 715-44-10',
    raw: '+79917154410',
  },
  {
    phone: '(989) 747-40-15',
    formatted: '+7 989 747-40-15',
    raw: '+79897474015',
  },
  {
    phone: '(988) 865-27-77',
    formatted: '+7 988 865-27-77',
    raw: '+79888652777',
  },
  {
    phone: '(988) 505-16-67',
    formatted: '+7 988 505-16-67',
    raw: '+79885051667',
  },
  {
    phone: '(988) 473-63-33',
    formatted: '+7 988 473-63-33',
    raw: '+79884736333',
  },
  {
    phone: '(988) 404-60-08',
    formatted: '+7 988 404-60-08',
    raw: '+79884046008',
  },
  {
    phone: '(988) 322-27-33',
    formatted: '+7 988 322-27-33',
    raw: '+79883222733',
  },
  {
    phone: '(988) 240-00-37',
    formatted: '+7 988 240-00-37',
    raw: '+79882400037',
  },
  {
    phone: '(987) 498-19-98',
    formatted: '+7 987 498-19-98',
    raw: '+79874981998',
  },
  {
    phone: '(983) 103-22-22',
    formatted: '+7 983 103-22-22',
    raw: '+79831032222',
  },
  {
    phone: '(982) 303-09-09',
    formatted: '+7 982 303-09-09',
    raw: '+79823030909',
  },
  {
    phone: '(978) 990-52-90, (365) 622-62-19',
    formatted: '+7 365 622-62-19',
    raw: '+73656226219',
  },
  {
    phone: '(978) 870-20-70',
    formatted: '+7 978 870-20-70',
    raw: '+79788702070',
  },
  {
    phone: '(978) 827-99-93',
    formatted: '+7 978 827-99-93',
    raw: '+79788279993',
  },
  {
    phone: '(978) 176-04 84',
    formatted: '+7 978 176-04-84',
    raw: '+79781760484',
  },
  {
    phone: '(969) 808‒12‒12',
    formatted: '+7 969 808-12-12',
    raw: '+79698081212',
  },
  {
    phone: '(969) 151-35-35',
    formatted: '+7 969 151-35-35',
    raw: '+79691513535',
  },
  {
    phone: '(968) 507-86-33,  (962) 971-81-07',
    formatted: '+7 962 971-81-07',
    raw: '+79629718107',
  },
  {
    phone: '(966) 888-06-32',
    formatted: '+7 966 888-06-32',
    raw: '+79668880632',
  },
  {
    phone: '(966) 124-88-33',
    formatted: '+7 966 124-88-33',
    raw: '+79661248833',
  },
  {
    phone: '(964) 037-61-29, (928) 080-72-61',
    formatted: '+7 928 080-72-61',
    raw: '+79280807261',
  },
  {
    phone: '(963) 411-11-33',
    formatted: '+7 963 411-11-33',
    raw: '+79634111133',
  },
  {
    phone: '(962) 556-56-86',
    formatted: '+7 962 556-56-86',
    raw: '+79625565686',
  },
  {
    phone: '(961) 590‒50‒50',
    formatted: '+7 961 590-50-50',
    raw: '+79615905050',
  },
  {
    phone: '(958) 760-32-85',
    formatted: '+7 958 760-32-85',
    raw: '+79587603285',
  },
  {
    phone: '(958) 188-09-11',
    formatted: '+7 958 188-09-11',
    raw: '+79581880911',
  },
  {
    phone: '(953) 773-19-00',
    formatted: '+7 953 773-19-00',
    raw: '+79537731900',
  },
  {
    phone: '(953) 113-36-74, (988) 770-12-99, (952) 830-09-39',
    formatted: '+7 952 830-09-39',
    raw: '+79528300939',
  },
  {
    phone: '(953) 081-28-00',
    formatted: '+7 953 081-28-00',
    raw: '+79530812800',
  },
  {
    phone: '(953) 079-00-03',
    formatted: '+7 953 079-00-03',
    raw: '+79530790003',
  },
  {
    phone: '(952) 555-44-49, (473) 232-29-09',
    formatted: '+7 473 232-29-09',
    raw: '+74732322909',
  },
  {
    phone: '(952) 287-45-57',
    formatted: '+7 952 287-45-57',
    raw: '+79522874557',
  },
  {
    phone: '(951) 859-22-17',
    formatted: '+7 951 859-22-17',
    raw: '+79518592217',
  },
  {
    phone: '(951) 324-18-43',
    formatted: '+7 951 324-18-43',
    raw: '+79513241843',
  },
  {
    phone: '(950) 520-10-10',
    formatted: '+7 950 520-10-10',
    raw: '+79505201010',
  },
  {
    phone: '(950) 482-72-72, (3452) 98-06-06',
    formatted: '+7 345 298-06-06',
    raw: '+73452980606',
  },
  {
    phone: '(938) 132-04-06',
    formatted: '+7 938 132-04-06',
    raw: '+79381320406',
  },
  {
    phone: '(937) 999-29-21',
    formatted: '+7 937 999-29-21',
    raw: '+79379992921',
  },
  {
    phone: '(937) 166-44-46',
    formatted: '+7 937 166-44-46',
    raw: '+79371664446',
  },
  {
    phone: '(931) 961-16-12',
    formatted: '+7 931 961-16-12',
    raw: '+79319611612',
  },
  {
    phone: '(930) 355-77-75',
    formatted: '+7 930 355-77-75',
    raw: '+79303557775',
  },
  {
    phone: '(929) 940-68-45, (495) 744-33-93',
    formatted: '+7 495 744-33-93',
    raw: '+74957443393',
  },
  {
    phone: '(929) 111-01-00',
    formatted: '+7 929 111-01-00',
    raw: '+79291110100',
  },
  {
    phone: '(928) 880-05-82',
    formatted: '+7 928 880-05-82',
    raw: '+79288800582',
  },
  {
    phone: '(927) 981-41-81, (8422) 21-41-81',
    formatted: '+7 842 221-41-81',
    raw: '+78422214181',
  },
  {
    phone: '(927) 919-18-20',
    formatted: '+7 927 919-18-20',
    raw: '+79279191820',
  },
  {
    phone: '(926) 907-24-85',
    formatted: '+7 926 907-24-85',
    raw: '+79269072485',
  },
  {
    phone: '(926) 760-18-58',
    formatted: '+7 926 760-18-58',
    raw: '+79267601858',
  },
  {
    phone: '(926) 317-63-55',
    formatted: '+7 926 317-63-55',
    raw: '+79263176355',
  },
  {
    phone: '(925) 939-14-77',
    formatted: '+7 925 939-14-77',
    raw: '+79259391477',
  },
  {
    phone: '(924) 677-99-90',
    formatted: '+7 924 677-99-90',
    raw: '+79246779990',
  },
  {
    phone: '(922) 235-32-35',
    formatted: '+7 922 235-32-35',
    raw: '+79222353235',
  },
  {
    phone: '(920) 226-45-93',
    formatted: '+7 920 226-45-93',
    raw: '+79202264593',
  },
  {
    phone: '(919) 508-83-34',
    formatted: '+7 919 508-83-34',
    raw: '+79195088334',
  },
  {
    phone: '(918) 737‒72‒99',
    formatted: '+7 918 737-72-99',
    raw: '+79187377299',
  },
  {
    phone: '(918) 428-06-87',
    formatted: '+7 918 428-06-87',
    raw: '+79184280687',
  },
  {
    phone: '(918) 428 -31-33, (961) 827-58-02',
    formatted: '+7 961 827-58-02',
    raw: '+79618275802',
  },
  {
    phone: '(918) 344-15-55',
    formatted: '+7 918 344-15-55',
    raw: '+79183441555',
  },
  {
    phone: '(918) 146-63-73',
    formatted: '+7 918 146-63-73',
    raw: '+79181466373',
  },
  {
    phone: '(918) 002-30-60',
    formatted: '+7 918 002-30-60',
    raw: '+79180023060',
  },
  {
    phone: '(917) 957-57-10',
    formatted: '+7 917 957-57-10',
    raw: '+79179575710',
  },
  {
    phone: '(916) 558-15-55',
    formatted: '+7 916 558-15-55',
    raw: '+79165581555',
  },
  {
    phone: '(916) 163-53-56',
    formatted: '+7 916 163-53-56',
    raw: '+79161635356',
  },
  {
    phone: '(915) 330-33-22',
    formatted: '+7 915 330-33-22',
    raw: '+79153303322',
  },
  {
    phone: '(915) 148-00-99',
    formatted: '+7 915 148-00-99',
    raw: '+79151480099',
  },
  {
    phone: '(914) 585-71-18',
    formatted: '+7 914 585-71-18',
    raw: '+79145857118',
  },
  {
    phone: '(914) 538-89-81',
    formatted: '+7 914 538-89-81',
    raw: '+79145388981',
  },
  {
    phone: '(913) 171-07-07',
    formatted: '+7 913 171-07-07',
    raw: '+79131710707',
  },
  {
    phone: '(912) 122-78-50',
    formatted: '+7 912 122-78-50',
    raw: '+79121227850',
  },
  {
    phone: '(912) 110-25-25',
    formatted: '+7 912 110-25-25',
    raw: '+79121102525',
  },
  {
    phone: '(912) 064-96-01',
    formatted: '+7 912 064-96-01',
    raw: '+79120649601',
  },
  {
    phone: '(911) 924-78-84',
    formatted: '+7 911 924-78-84',
    raw: '+79119247884',
  },
  {
    phone: '(911) 911-41-81',
    formatted: '+7 911 911-41-81',
    raw: '+79119114181',
  },
  {
    phone: '(911) 505-13-25',
    formatted: '+7 911 505-13-25',
    raw: '+79115051325',
  },
  {
    phone: '(911) 205-55-58',
    formatted: '+7 911 205-55-58',
    raw: '+79112055558',
  },
  {
    phone: '(909) 604-20-20',
    formatted: '+7 909 604-20-20',
    raw: '+79096042020',
  },
  {
    phone: '(909) 603-0-770',
    formatted: '+7 909 603-07-70',
    raw: '+79096030770',
  },
  {
    phone: '(909) 377-88-99',
    formatted: '+7 909 377-88-99',
    raw: '+79093778899',
  },
  {
    phone: '(908) 614-13-23',
    formatted: '+7 908 614-13-23',
    raw: '+79086141323',
  },
  {
    phone: '(908) 223-43-54',
    formatted: '+7 908 223-43-54',
    raw: '+79082234354',
  },
  {
    phone: '(908) 147-90-87',
    formatted: '+7 908 147-90-87',
    raw: '+79081479087',
  },
  {
    phone: '(906) 963-37-33',
    formatted: '+7 906 963-37-33',
    raw: '+79069633733',
  },
  {
    phone: '(906) 913-89-49',
    formatted: '+7 906 913-89-49',
    raw: '+79069138949',
  },
  {
    phone: '(906) 110-25-01',
    formatted: '+7 906 110-25-01',
    raw: '+79061102501',
  },
  {
    phone: '(904) 961-22-99',
    formatted: '+7 904 961-22-99',
    raw: '+79049612299',
  },
  {
    phone: '(904) 819-05-72, (904) 819-05-72',
    formatted: '+7 904 819-05-72',
    raw: '+79048190572',
  },
  {
    phone: '(903) 990-55-99',
    formatted: '+7 903 990-55-99',
    raw: '+79039905599',
  },
  {
    phone: '(903) 917-39-39',
    formatted: '+7 903 917-39-39',
    raw: '+79039173939',
  },
  {
    phone: '(903) 523-03-36',
    formatted: '+7 903 523-03-36',
    raw: '+79035230336',
  },
  {
    phone: '(903) 221-48-23',
    formatted: '+7 903 221-48-23',
    raw: '+79032214823',
  },
  {
    phone: '(903) 099-19-91',
    formatted: '+7 903 099-19-91',
    raw: '+79030991991',
  },
  {
    phone: '(902) 424-65-58',
    formatted: '+7 902 424-65-58',
    raw: '+79024246558',
  },
  {
    phone: '(900) 142-02-22',
    formatted: '+7 900 142-02-22',
    raw: '+79001420222',
  },
  {
    phone: '(8793) 97-38-11',
    formatted: '+7 879 397-38-11',
    raw: '+78793973811',
  },
  {
    phone: '(8793) 39-45-54, (8793) 39-37-21',
    formatted: '+7 879 339-37-21',
    raw: '+78793393721',
  },
  {
    phone: '(87922) 6-78-82',
    formatted: '+7 879 226-78-82',
    raw: '+78792267882',
  },
  {
    phone: '(8782) 26–21–98',
    formatted: '+7 878 226-21-98',
    raw: '+78782262198',
  },
  {
    phone: '(8722) 55-01-79, (8722) 99-02-00',
    formatted: '+7 872 299-02-00',
    raw: '+78722990200',
  },
  {
    phone: '(8692) 53-33-33',
    formatted: '+7 869 253-33-33',
    raw: '+78692533333',
  },
  {
    phone: '(8672) 501-333',
    formatted: '+7 867 250-13-33',
    raw: '+78672501333',
  },
  {
    phone: '(867) 323-38-66',
    formatted: '+7 867 323-38-66',
    raw: '+78673233866',
  },
  {
    phone: '(86555) 5-09-51',
    formatted: '+7 865 555-09-51',
    raw: '+78655550951',
  },
  {
    phone: '(86554) 6-32-39',
    formatted: '+7 865 546-32-39',
    raw: '+78655463239',
  },
  {
    phone: '(8652) 99-89-89',
    formatted: '+7 865 299-89-89',
    raw: '+78652998989',
  },
  {
    phone: '(8652) 99-70-03',
    formatted: '+7 865 299-70-03',
    raw: '+78652997003',
  },
  {
    phone: '(8652) 94-24-64',
    formatted: '+7 865 294-24-64',
    raw: '+78652942464',
  },
  {
    phone: '(8652) 40-66-52',
    formatted: '+7 865 240-66-52',
    raw: '+78652406652',
  },
  {
    phone: '(8636) 28-98-23',
    formatted: '+7 863 628-98-23',
    raw: '+78636289823',
  },
  {
    phone: '(8636) 22-70-61',
    formatted: '+7 863 622-70-61',
    raw: '+78636227061',
  },
  {
    phone: '(863) 333-23-24',
    formatted: '+7 863 333-23-24',
    raw: '+78633332324',
  },
  {
    phone: '(863) 232-16-16',
    formatted: '+7 863 232-16-16',
    raw: '+78632321616',
  },
  {
    phone: '(863) 231-56-42',
    formatted: '+7 863 231-56-42',
    raw: '+78632315642',
  },
  {
    phone: '(863) 230-63-03',
    formatted: '+7 863 230-63-03',
    raw: '+78632306303',
  },
  {
    phone: '(863) 208-09-09',
    formatted: '+7 863 208-09-09',
    raw: '+78632080909',
  },
  {
    phone: '(8622) 77-72-97',
    formatted: '+7 862 277-72-97',
    raw: '+78622777297',
  },
  {
    phone: '(862) 277-74-50',
    formatted: '+7 862 277-74-50',
    raw: '+78622777450',
  },
  {
    phone: '(862) 250-51-03',
    formatted: '+7 862 250-51-03',
    raw: '+78622505103',
  },
  {
    phone: '(8617) 61-51-14',
    formatted: '+7 861 761-51-14',
    raw: '+78617615114',
  },
  {
    phone: '(86164) 7-11-00',
    formatted: '+7 861 647-11-00',
    raw: '+78616471100',
  },
  {
    phone: '(861) 258-88-04',
    formatted: '+7 861 258-88-04',
    raw: '+78612588804',
  },
  {
    phone: '(861) 253-05-05',
    formatted: '+7 861 253-05-05',
    raw: '+78612530505',
  },
  {
    phone: '(861) 252-68-68',
    formatted: '+7 861 252-68-68',
    raw: '+78612526868',
  },
  {
    phone: '(861) 225-08-44',
    formatted: '+7 861 225-08-44',
    raw: '+78612250844',
  },
  {
    phone: '(85558) 7-50-16',
    formatted: '+7 855 587-50-16',
    raw: '+78555875016',
  },
  {
    phone: '(8552) 47-58-95',
    formatted: '+7 855 247-58-95',
    raw: '+78552475895',
  },
  {
    phone: '(8512) 62-39-90',
    formatted: '+7 851 262-39-90',
    raw: '+78512623990',
  },
  {
    phone: '(8512) 25-37-00',
    formatted: '+7 851 225-37-00',
    raw: '+78512253700',
  },
  {
    phone: '(8512) 22-32-52',
    formatted: '+7 851 222-32-52',
    raw: '+78512223252',
  },
  {
    phone: '(8512) 22-30-22',
    formatted: '+7 851 222-30-22',
    raw: '+78512223022',
  },
  {
    phone: '(8482) 76-07-60',
    formatted: '+7 848 276-07-60',
    raw: '+78482760760',
  },
  {
    phone: '(8482) 61-34-95',
    formatted: '+7 848 261-34-95',
    raw: '+78482613495',
  },
  {
    phone: '(8482) 500-111',
    formatted: '+7 848 250-01-11',
    raw: '+78482500111',
  },
  {
    phone: '(8464) 91-61-84',
    formatted: '+7 846 491-61-84',
    raw: '+78464916184',
  },
  {
    phone: '(846) 998-91-86',
    formatted: '+7 846 998-91-86',
    raw: '+78469989186',
  },
  {
    phone: '(846) 996-88-32',
    formatted: '+7 846 996-88-32',
    raw: '+78469968832',
  },
  {
    phone: '(846) 994-36-02',
    formatted: '+7 846 994-36-02',
    raw: '+78469943602',
  },
  {
    phone: '(846) 975-33-83',
    formatted: '+7 846 975-33-83',
    raw: '+78469753383',
  },
  {
    phone: '(846) 955-10-24',
    formatted: '+7 846 955-10-24',
    raw: '+78469551024',
  },
  {
    phone: '(846) 925-88-52, (846) 925-23-02',
    formatted: '+7 846 925-23-02',
    raw: '+78469252302',
  },
  {
    phone: '(846) 337-62-49',
    formatted: '+7 846 337-62-49',
    raw: '+78463376249',
  },
  {
    phone: '(846) 310-28-04',
    formatted: '+7 846 310-28-04',
    raw: '+78463102804',
  },
  {
    phone: '(846) 277-69-69',
    formatted: '+7 846 277-69-69',
    raw: '+78462776969',
  },
  {
    phone: '(846) 250-05-15',
    formatted: '+7 846 250-05-15',
    raw: '+78462500515',
  },
  {
    phone: '(846) 212-50-88, (927) 776-98-88',
    formatted: '+7 927 776-98-88',
    raw: '+79277769888',
  },
  {
    phone: '(84545) 30-093',
    formatted: '+7 845 453-00-93',
    raw: '+78454530093',
  },
  {
    phone: '(8452) 79-24-42',
    formatted: '+7 845 279-24-42',
    raw: '+78452792442',
  },
  {
    phone: '(8443) 45-91-01, (937) 556-61-77',
    formatted: '+7 937 556-61-77',
    raw: '+79375566177',
  },
  {
    phone: '(8442) 58-10-57',
    formatted: '+7 844 258-10-57',
    raw: '+78442581057',
  },
  {
    phone: '(8442) 269-269; (903) 372-00-03',
    formatted: '+7 903 372-00-03',
    raw: '+79033720003',
  },
  {
    phone: '(8432) 321-49',
    formatted: '(8432) 321-49',
    raw: '843232149',
  },
  {
    phone: '(843) 265-10-03',
    formatted: '+7 843 265-10-03',
    raw: '+78432651003',
  },
  {
    phone: '(843) 240-32-08',
    formatted: '+7 843 240-32-08',
    raw: '+78432403208',
  },
  {
    phone: '(843) 224-32-52',
    formatted: '+7 843 224-32-52',
    raw: '+78432243252',
  },
  {
    phone: '(8422) 59-91-07',
    formatted: '+7 842 259-91-07',
    raw: '+78422599107',
  },
  {
    phone: '(8422) 52-62-44',
    formatted: '+7 842 252-62-44',
    raw: '+78422526244',
  },
  {
    phone: '(8422) 44-17-65',
    formatted: '+7 842 244-17-65',
    raw: '+78422441765',
  },
  {
    phone: '(8422) 43‒55‒55, (927) 812‒34‒66',
    formatted: '+7 927 812-34-66',
    raw: '+79278123466',
  },
  {
    phone: '(8422) 422-122',
    formatted: '+7 842 242-21-22',
    raw: '+78422422122',
  },
  {
    phone: '(8422) 411-600',
    formatted: '+7 842 241-16-00',
    raw: '+78422411600',
  },
  {
    phone: '(8412) 555-111',
    formatted: '+7 841 255-51-11',
    raw: '+78412555111',
  },
  {
    phone: '(8412) 55-00-90',
    formatted: '+7 841 255-00-90',
    raw: '+78412550090',
  },
  {
    phone: '(8412) 26-08-79',
    formatted: '+7 841 226-08-79',
    raw: '+78412260879',
  },
  {
    phone: '(83531) 5-05-02',
    formatted: '+7 835 315-05-02',
    raw: '+78353150502',
  },
  {
    phone: '(8352) 23-58-02',
    formatted: '+7 835 223-58-02',
    raw: '+78352235802',
  },
  {
    phone: '(8352) 203-323',
    formatted: '+7 835 220-33-23',
    raw: '+78352203323',
  },
  {
    phone: '(8342) 55-97-09',
    formatted: '+7 834 255-97-09',
    raw: '+78342559709',
  },
  {
    phone: '(8342) 23-41-53',
    formatted: '+7 834 223-41-53',
    raw: '+78342234153',
  },
  {
    phone: '(83361) 2-08-44',
    formatted: '+7 833 612-08-44',
    raw: '+78336120844',
  },
  {
    phone: '(8332) 77-88-55, 32-33-88',
    formatted: '+7 833 277-88-55',
    raw: '+78332778855',
  },
  {
    phone: '(8332) 52-71-82',
    formatted: '+7 833 252-71-82',
    raw: '+78332527182',
  },
  {
    phone: '(83172) 5-29-52',
    formatted: '+7 831 725-29-52',
    raw: '+78317252952',
  },
  {
    phone: '(83144) 749-17',
    formatted: '+7 831 447-49-17',
    raw: '+78314474917',
  },
  {
    phone: '(831) 279-43-30',
    formatted: '+7 831 279-43-30',
    raw: '+78312794330',
  },
  {
    phone: '(831) 271-73-53',
    formatted: '+7 831 271-73-53',
    raw: '+78312717353',
  },
  {
    phone: '(831) 265 32 21',
    formatted: '+7 831 265-32-21',
    raw: '+78312653221',
  },
  {
    phone: '(8216) 76-99-76',
    formatted: '+7 821 676-99-76',
    raw: '+78216769976',
  },
  {
    phone: '(8212) 40-01-03',
    formatted: '+7 821 240-01-03',
    raw: '+78212400103',
  },
  {
    phone: '(8202) 30-22-11, (911) 046-36-36, (8202) 30-22-22',
    formatted: '+7 820 230-22-22',
    raw: '+78202302222',
  },
  {
    phone: '(8182) 65-32-20',
    formatted: '+7 818 265-32-20',
    raw: '+78182653220',
  },
  {
    phone: '(8182) 600-145',
    formatted: '+7 818 260-01-45',
    raw: '+78182600145',
  },
  {
    phone: '(8182) 47-49-00',
    formatted: '+7 818 247-49-00',
    raw: '+78182474900',
  },
  {
    phone: '(8182) 47-02-75',
    formatted: '+7 818 247-02-75',
    raw: '+78182470275',
  },
  {
    phone: '(8182) 21-54-05',
    formatted: '+7 818 221-54-05',
    raw: '+78182215405',
  },
  {
    phone: '(81739) 6-11-32',
    formatted: '+7 817 396-11-32',
    raw: '+78173961132',
  },
  {
    phone: '(81732) 2-12-97',
    formatted: '+7 817 322-12-97',
    raw: '+78173221297',
  },
  {
    phone: '(8172) 78-53-20',
    formatted: '+7 817 278-53-20',
    raw: '+78172785320',
  },
  {
    phone: '(8172) 50-24-42',
    formatted: '+7 817 250-24-42',
    raw: '+78172502442',
  },
  {
    phone: '(8172) 27-73-76',
    formatted: '+7 817 227-73-76',
    raw: '+78172277376',
  },
  {
    phone: '(8172) 21-08-27',
    formatted: '+7 817 221-08-27',
    raw: '+78172210827',
  },
  {
    phone: '(8162) 73-99-66',
    formatted: '+7 816 273-99-66',
    raw: '+78162739966',
  },
  {
    phone: '(8152) 56-69-69',
    formatted: '+7 815 256-69-69',
    raw: '+78152566969',
  },
  {
    phone: '(812) 963-05-00',
    formatted: '+7 812 963-05-00',
    raw: '+78129630500',
  },
  {
    phone: '(812) 770-40-21',
    formatted: '+7 812 770-40-21',
    raw: '+78127704021',
  },
  {
    phone: '(812) 770-30-77',
    formatted: '+7 812 770-30-77',
    raw: '+78127703077',
  },
  {
    phone: '(812) 705-49-82',
    formatted: '+7 812 705-49-82',
    raw: '+78127054982',
  },
  {
    phone: '(812) 701-06-33',
    formatted: '+7 812 701-06-33',
    raw: '+78127010633',
  },
  {
    phone: '(812) 646-89-99',
    formatted: '+7 812 646-89-99',
    raw: '+78126468999',
  },
  {
    phone: '(812) 643-34-13',
    formatted: '+7 812 643-34-13',
    raw: '+78126433413',
  },
  {
    phone: '(812) 640-01-42',
    formatted: '+7 812 640-01-42',
    raw: '+78126400142',
  },
  {
    phone: '(812) 611-33-03',
    formatted: '+7 812 611-33-03',
    raw: '+78126113303',
  },
  {
    phone: '(812) 602-17-17',
    formatted: '+7 812 602-17-17',
    raw: '+78126021717',
  },
  {
    phone: '(812) 577-19-45',
    formatted: '+7 812 577-19-45',
    raw: '+78125771945',
  },
  {
    phone: '(812) 573-93-75',
    formatted: '+7 812 573-93-75',
    raw: '+78125739375',
  },
  {
    phone: '(812) 490-45-48',
    formatted: '+7 812 490-45-48',
    raw: '+78124904548',
  },
  {
    phone: '(812) 421-42-36',
    formatted: '+7 812 421-42-36',
    raw: '+78124214236',
  },
  {
    phone: '(812) 409-76-28',
    formatted: '+7 812 409-76-28',
    raw: '+78124097628',
  },
  {
    phone: '(812) 384-15-68',
    formatted: '+7 812 384-15-68',
    raw: '+78123841568',
  },
  {
    phone: '(812) 38 07 387',
    formatted: '+7 812 380-73-87',
    raw: '+78123807387',
  },
  {
    phone: '(812) 327-51-54',
    formatted: '+7 812 327-51-54',
    raw: '+78123275154',
  },
  {
    phone: '(812) 315-48-71',
    formatted: '+7 812 315-48-71',
    raw: '+78123154871',
  },
  {
    phone: '(812) 309-97-55, (812) 554-07-70',
    formatted: '+7 812 554-07-70',
    raw: '+78125540770',
  },
  {
    phone: '(812) 309-82-09',
    formatted: '+7 812 309-82-09',
    raw: '+78123098209',
  },
  {
    phone: '(812) 246-26-72',
    formatted: '+7 812 246-26-72',
    raw: '+78122462672',
  },
  {
    phone: '(812) 245-07-07, (965) 760-07-07',
    formatted: '+7 965 760-07-07',
    raw: '+79657600707',
  },
  {
    phone: '(812) 244-59-59',
    formatted: '+7 812 244-59-59',
    raw: '+78122445959',
  },
  {
    phone: '(812) 200-98-10',
    formatted: '+7 812 200-98-10',
    raw: '+78122009810',
  },
  {
    phone: '(8112) 55-20-22, (911) 396-77-73',
    formatted: '+7 911 396-77-73',
    raw: '+79113967773',
  },
  {
    phone: '(8112) 29-85-47',
    formatted: '+7 811 229-85-47',
    raw: '+78112298547',
  },
  {
    phone: '(800) 777-31-31',
    formatted: '8 800 777-31-31',
    raw: '88007773131',
  },
  {
    phone: '(800) 775-65-37',
    formatted: '8 800 775-65-37',
    raw: '88007756537',
  },
  {
    phone: '(800) 707-90-24',
    formatted: '8 800 707-90-24',
    raw: '88007079024',
  },
  {
    phone: '(800) 550-73-57',
    formatted: '8 800 550-73-57',
    raw: '88005507357',
  },
  {
    phone: '(800) 500-15-03',
    formatted: '8 800 500-15-03',
    raw: '88005001503',
  },
  {
    phone: '(800) 301-1401',
    formatted: '8 800 301-14-01',
    raw: '88003011401',
  },
  {
    phone: '(800) 300-48-37, (904) 444-20-90',
    formatted: '+7 904 444-20-90',
    raw: '+79044442090',
  },
  {
    phone: '(800) 222‒83‒31, (929) 833‒53‒38',
    formatted: '+7 929 833-53-38',
    raw: '+79298335338',
  },
  {
    phone: '(800) 200-60-08',
    formatted: '8 800 200-60-08',
    raw: '88002006008',
  },
  {
    phone: '(800) 101-89-92, (48143) 5-29-92, (910) 112-12-09',
    formatted: '+7 910 112-12-09',
    raw: '+79101121209',
  },
  {
    phone: '(800) 100-36-30; (347) 683-55-85; (347) 200-84-55',
    formatted: '+7 347 200-84-55',
    raw: '+73472008455',
  },
  {
    phone: '(499) 796-05-13',
    formatted: '+7 499 796-05-13',
    raw: '+74997960513',
  },
  {
    phone: '(499) 762-62-00, (499) 762-62-02',
    formatted: '+7 499 762-62-02',
    raw: '+74997626202',
  },
  {
    phone: '(499) 717-01-73',
    formatted: '+7 499 717-01-73',
    raw: '+74997170173',
  },
  {
    phone: '(499) 714-82-13',
    formatted: '+7 499 714-82-13',
    raw: '+74997148213',
  },
  {
    phone: '(499) 623-90-51',
    formatted: '+7 499 623-90-51',
    raw: '+74996239051',
  },
  {
    phone: '(499) 444-09-47',
    formatted: '+7 499 444-09-47',
    raw: '+74994440947',
  },
  {
    phone: '(499) 401-95-00',
    formatted: '+7 499 401-95-00',
    raw: '+74994019500',
  },
  {
    phone: '(499) 401-94-98',
    formatted: '+7 499 401-94-98',
    raw: '+74994019498',
  },
  {
    phone: '(499) 391-19-11',
    formatted: '+7 499 391-19-11',
    raw: '+74993911911',
  },
  {
    phone: '(499) 324-31-30, (495) 150-99-93',
    formatted: '+7 495 150-99-93',
    raw: '+74951509993',
  },
  {
    phone: '(499) 248-79-35',
    formatted: '+7 499 248-79-35',
    raw: '+74992487935',
  },
  {
    phone: '(499) 245-92-00',
    formatted: '+7 499 245-92-00',
    raw: '+74992459200',
  },
  {
    phone: '(499) 210-20-30, (499) 210-20-40',
    formatted: '+7 499 210-20-40',
    raw: '+74992102040',
  },
  {
    phone: '(499) 192-12-23, (966) 122-12-23',
    formatted: '+7 966 122-12-23',
    raw: '+79661221223',
  },
  {
    phone: '(499) 158-99-05',
    formatted: '+7 499 158-99-05',
    raw: '+74991589905',
  },
  {
    phone: '(499) 112-10-52',
    formatted: '+7 499 112-10-52',
    raw: '+74991121052',
  },
  {
    phone: '(498) 715-74-74',
    formatted: '+7 498 715-74-74',
    raw: '+74987157474',
  },
  {
    phone: '(49672) 7-53-43',
    formatted: '+7 496 727-53-43',
    raw: '+74967275343',
  },
  {
    phone: '(4967) 54-41-04',
    formatted: '+7 496 754-41-04',
    raw: '+74967544104',
  },
  {
    phone: '(49622) 5-29-02',
    formatted: '+7 496 225-29-02',
    raw: '+74962252902',
  },
  {
    phone: '(49621) 8-08-09, (925) 415-08-68',
    formatted: '+7 925 415-08-68',
    raw: '+79254150868',
  },
  {
    phone: '(496) 635-35-48',
    formatted: '+7 496 635-35-48',
    raw: '+74966353548',
  },
  {
    phone: '(496) 610-03-10',
    formatted: '+7 496 610-03-10',
    raw: '+74966100310',
  },
  {
    phone: '(496) 58 6 71 01',
    formatted: '+7 496 586-71-01',
    raw: '+74965867101',
  },
  {
    phone: '(495) 988-47-89',
    formatted: '+7 495 988-47-89',
    raw: '+74959884789',
  },
  {
    phone: '(495) 971-97-97, (495) 417-41-17',
    formatted: '+7 495 417-41-17',
    raw: '+74954174117',
  },
  {
    phone: '(495) 970-18-15, (495) 988-83-35',
    formatted: '+7 495 988-83-35',
    raw: '+74959888335',
  },
  {
    phone: '(495) 960-93-03, (495) 126-90-47',
    formatted: '+7 495 126-90-47',
    raw: '+74951269047',
  },
  {
    phone: '(495) 920-60-42',
    formatted: '+7 495 920-60-42',
    raw: '+74959206042',
  },
  {
    phone: '(495) 914‒11‒72',
    formatted: '+7 495 914-11-72',
    raw: '+74959141172',
  },
  {
    phone: '(495) 822-00-77',
    formatted: '+7 495 822-00-77',
    raw: '+74958220077',
  },
  {
    phone: '(495) 771-72-60',
    formatted: '+7 495 771-72-60',
    raw: '+74957717260',
  },
  {
    phone: '(495) 740-33-03, (499) 722-26-85, (499) 722-29-39',
    formatted: '+7 499 722-29-39',
    raw: '+74997222939',
  },
  {
    phone: '(495) 642-45-76',
    formatted: '+7 495 642-45-76',
    raw: '+74956424576',
  },
  {
    phone: '(495) 633-25-25, (495) 633-26-26',
    formatted: '+7 495 633-26-26',
    raw: '+74956332626',
  },
  {
    phone: '(495) 614-26-60, (495) 614-59-38',
    formatted: '+7 495 614-59-38',
    raw: '+74956145938',
  },
  {
    phone: '(495) 568-13-03',
    formatted: '+7 495 568-13-03',
    raw: '+74955681303',
  },
  {
    phone: '(495) 529-52-90',
    formatted: '+7 495 529-52-90',
    raw: '+74955295290',
  },
  {
    phone: '(495) 511-63-63',
    formatted: '+7 495 511-63-63',
    raw: '+74955116363',
  },
  {
    phone: '(495) 510-43-01',
    formatted: '+7 495 510-43-01',
    raw: '+74955104301',
  },
  {
    phone: '(495) 508-25-34',
    formatted: '+7 495 508-25-34',
    raw: '+74955082534',
  },
  {
    phone: '(495) 466-00-47',
    formatted: '+7 495 466-00-47',
    raw: '+74954660047',
  },
  {
    phone: '(495) 324-67-77',
    formatted: '+7 495 324-67-77',
    raw: '+74953246777',
  },
  {
    phone: '(495) 281-50-55',
    formatted: '+7 495 281-50-55',
    raw: '+74952815055',
  },
  {
    phone: '(495) 255-48-23',
    formatted: '+7 495 255-48-23',
    raw: '+74952554823',
  },
  {
    phone: '(495) 241-89-37, (495) 154-10-81',
    formatted: '+7 495 154-10-81',
    raw: '+74951541081',
  },
  {
    phone: '(495) 228-69-80, (495) 877-35-67',
    formatted: '+7 495 877-35-67',
    raw: '+74958773567',
  },
  {
    phone: '(495) 191-21-56, (495) 846-81-28',
    formatted: '+7 495 846-81-28',
    raw: '+74958468128',
  },
  {
    phone: '(495) 191-05-94',
    formatted: '+7 495 191-05-94',
    raw: '+74951910594',
  },
  {
    phone: '(495) 182-44-15',
    formatted: '+7 495 182-44-15',
    raw: '+74951824415',
  },
  {
    phone: '(495) 150-80-50, (495) 159-51-46',
    formatted: '+7 495 159-51-46',
    raw: '+74951595146',
  },
  {
    phone: '(495) 150-51-96',
    formatted: '+7 495 150-51-96',
    raw: '+74951505196',
  },
  {
    phone: '(495) 136-23-42',
    formatted: '+7 495 136-23-42',
    raw: '+74951362342',
  },
  {
    phone: '(495) 135-35-36',
    formatted: '+7 495 135-35-36',
    raw: '+74951353536',
  },
  {
    phone: '(495) 125-13-31',
    formatted: '+7 495 125-13-31',
    raw: '+74951251331',
  },
  {
    phone: '(495) 122-02-21, 122',
    formatted: '+7 495 122-02-21',
    raw: '+74951220221',
  },
  {
    phone: '(495) 121-30-96',
    formatted: '+7 495 121-30-96',
    raw: '+74951213096',
  },
  {
    phone: '(495) 021-55-12',
    formatted: '+7 495 021-55-12',
    raw: '+74950215512',
  },
  {
    phone: '(49343) 4-03-60',
    formatted: '+7 493 434-03-60',
    raw: '+74934340360',
  },
  {
    phone: '(49343) 2-26-58',
    formatted: '+7 493 432-26-58',
    raw: '+74934322658',
  },
  {
    phone: '(4932) 49-75-80',
    formatted: '+7 493 249-75-80',
    raw: '+74932497580',
  },
  {
    phone: '(49241) 5-02-36',
    formatted: '+7 492 415-02-36',
    raw: '+74924150236',
  },
  {
    phone: '(4922) 53-63-11',
    formatted: '+7 492 253-63-11',
    raw: '+74922536311',
  },
  {
    phone: '(4922) 24-47-21',
    formatted: '+7 492 224-47-21',
    raw: '+74922244721',
  },
  {
    phone: '(4872) 26-92-77, (939) 859-92-77',
    formatted: '+7 939 859-92-77',
    raw: '+79398599277',
  },
  {
    phone: '(4855) 20-83-21',
    formatted: '+7 485 520-83-21',
    raw: '+74855208321',
  },
  {
    phone: '(4852) 74-66-16',
    formatted: '+7 485 274-66-16',
    raw: '+74852746616',
  },
  {
    phone: '(4852) 72-71-89',
    formatted: '+7 485 272-71-89',
    raw: '+74852727189',
  },
  {
    phone: '(4842) 72-55-50',
    formatted: '+7 484 272-55-50',
    raw: '+74842725550',
  },
  {
    phone: '(4842) 72-47-20',
    formatted: '+7 484 272-47-20',
    raw: '+74842724720',
  },
  {
    phone: '(4842) 57-01-74',
    formatted: '+7 484 257-01-74',
    raw: '+74842570174',
  },
  {
    phone: '(4842) 53-68-94',
    formatted: '+7 484 253-68-94',
    raw: '+74842536894',
  },
  {
    phone: '(4842) 51-58-79',
    formatted: '+7 484 251-58-79',
    raw: '+74842515879',
  },
  {
    phone: '(4832) 94-11-86',
    formatted: '+7 483 294-11-86',
    raw: '+74832941186',
  },
  {
    phone: '(4832) 73-30-03',
    formatted: '+7 483 273-30-03',
    raw: '+74832733003',
  },
  {
    phone: '(4832) 27-72-52',
    formatted: '+7 483 227-72-52',
    raw: '+74832277252',
  },
  {
    phone: '(48235) 2-17-39',
    formatted: '+7 482 352-17-39',
    raw: '+74823521739',
  },
  {
    phone: '(4822) 52-72-72',
    formatted: '+7 482 252-72-72',
    raw: '+74822527272',
  },
  {
    phone: '(4822) 44-36-36',
    formatted: '+7 482 244-36-36',
    raw: '+74822443636',
  },
  {
    phone: '(4822) 35-65-98',
    formatted: '+7 482 235-65-98',
    raw: '+74822356598',
  },
  {
    phone: '(4822) 34-74-78',
    formatted: '+7 482 234-74-78',
    raw: '+74822347478',
  },
  {
    phone: '(4812) 55-55-92',
    formatted: '+7 481 255-55-92',
    raw: '+74812555592',
  },
  {
    phone: '(4812) 42-58-38',
    formatted: '+7 481 242-58-38',
    raw: '+74812425838',
  },
  {
    phone: '(4812) 40-98-76',
    formatted: '+7 481 240-98-76',
    raw: '+74812409876',
  },
  {
    phone: '(4812) 33-99-76',
    formatted: '+7 481 233-99-76',
    raw: '+74812339976',
  },
  {
    phone: '(4752) 72-44-23',
    formatted: '+7 475 272-44-23',
    raw: '+74752724423',
  },
  {
    phone: '(4752) 55-92-25, (901) 204-95-95',
    formatted: '+7 901 204-95-95',
    raw: '+79012049595',
  },
  {
    phone: '(4752) 45-97-58',
    formatted: '+7 475 245-97-58',
    raw: '+74752459758',
  },
  {
    phone: '(4752) 42-45-49',
    formatted: '+7 475 242-45-49',
    raw: '+74752424549',
  },
  {
    phone: '(4742) 55-18-34',
    formatted: '+7 474 255-18-34',
    raw: '+74742551834',
  },
  {
    phone: '(4742) 33-01-78',
    formatted: '+7 474 233-01-78',
    raw: '+74742330178',
  },
  {
    phone: '(4742) 27-16-37',
    formatted: '+7 474 227-16-37',
    raw: '+74742271637',
  },
  {
    phone: '(47348) 3-04-05',
    formatted: '+7 473 483-04-05',
    raw: '+74734830405',
  },
  {
    phone: '(473) 270-71-40',
    formatted: '+7 473 270-71-40',
    raw: '+74732707140',
  },
  {
    phone: '(473) 202-11-51',
    formatted: '+7 473 202-11-51',
    raw: '+74732021151',
  },
  {
    phone: '(4725) 42-04-24',
    formatted: '+7 472 542-04-24',
    raw: '+74725420424',
  },
  {
    phone: '(4722) 53-25-94',
    formatted: '+7 472 253-25-94',
    raw: '+74722532594',
  },
  {
    phone: '(4722) 50-17-18',
    formatted: '+7 472 250-17-18',
    raw: '+74722501718',
  },
  {
    phone: '(47131) 732-000',
    formatted: '+7 713 173-20-00',
    raw: '+77131732000',
  },
  {
    phone: '(4712) 77-31-33',
    formatted: '+7 471 277-31-33',
    raw: '+74712773133',
  },
  {
    phone: '(4712) 59-93-40',
    formatted: '+7 471 259-93-40',
    raw: '+74712599340',
  },
  {
    phone: '(4712) 54-71-27',
    formatted: '+7 471 254-71-27',
    raw: '+74712547127',
  },
  {
    phone: '(42356) 34-2-83,  (908) 443-66-95',
    formatted: '+7 908 443-66-95',
    raw: '+79084436695',
  },
  {
    phone: '(42355) 9-33-91',
    formatted: '+7 423 559-33-91',
    raw: '+74235593391',
  },
  {
    phone: '(4234) 39-85-48',
    formatted: '+7 423 439-85-48',
    raw: '+74234398548',
  },
  {
    phone: '(4234) 30-07-00',
    formatted: '+7 423 430-07-00',
    raw: '+74234300700',
  },
  {
    phone: '(423)241-85-67, (423) 241-55-99',
    formatted: '+7 423 241-55-99',
    raw: '+74232415599',
  },
  {
    phone: '(423) 272-08-11',
    formatted: '+7 423 272-08-11',
    raw: '+74232720811',
  },
  {
    phone: '(423) 242-37-24',
    formatted: '+7 423 242-37-24',
    raw: '+74232423724',
  },
  {
    phone: '(423) 222-00-44',
    formatted: '+7 423 222-00-44',
    raw: '+74232220044',
  },
  {
    phone: '(42142) 2-43-80',
    formatted: '+7 421 422-43-80',
    raw: '+74214224380',
  },
  {
    phone: '(4212) 90-03-30',
    formatted: '+7 421 290-03-30',
    raw: '+74212900330',
  },
  {
    phone: '(4212) 66-90-55, (909) 823-90-55',
    formatted: '+7 909 823-90-55',
    raw: '+79098239055',
  },
  {
    phone: '(4212) 65-03-25',
    formatted: '+7 421 265-03-25',
    raw: '+74212650325',
  },
  {
    phone: '(4212) 21-84-32',
    formatted: '+7 421 221-84-32',
    raw: '+74212218432',
  },
  {
    phone: '(4212) 20-40-05',
    formatted: '+7 421 220-40-05',
    raw: '+74212204005',
  },
  {
    phone: '(41643) 2-15-85',
    formatted: '+7 416 432-15-85',
    raw: '+74164321585',
  },
  {
    phone: '(416) 277-88-88',
    formatted: '+7 416 277-88-88',
    raw: '+74162778888',
  },
  {
    phone: '(4112) 454-526',
    formatted: '+7 411 245-45-26',
    raw: '+74112454526',
  },
  {
    phone: '(4112) 40-82-68',
    formatted: '+7 411 240-82-68',
    raw: '+74112408268',
  },
  {
    phone: '(40150) 3-21-91',
    formatted: '+7 401 503-21-91',
    raw: '+74015032191',
  },
  {
    phone: '(4012) 36-08-80',
    formatted: '+7 401 236-08-80',
    raw: '+74012360880',
  },
  {
    phone: '(39561) 525-01',
    formatted: '+7 395 615-25-01',
    raw: '+73956152501',
  },
  {
    phone: '(3955) 67-83-57, (3955) 67-40-12',
    formatted: '+7 395 567-40-12',
    raw: '+73955674012',
  },
  {
    phone: '(3953) 348-488',
    formatted: '+7 395 334-84-88',
    raw: '+73953348488',
  },
  {
    phone: '(3953) 20-95-76',
    formatted: '+7 395 320-95-76',
    raw: '+73953209576',
  },
  {
    phone: '(3952) 965-701',
    formatted: '+7 395 296-57-01',
    raw: '+73952965701',
  },
  {
    phone: '(3952) 73-43-53',
    formatted: '+7 395 273-43-53',
    raw: '+73952734353',
  },
  {
    phone: '(3952) 70-70-81',
    formatted: '+7 395 270-70-81',
    raw: '+73952707081',
  },
  {
    phone: '(3952) 55-53-26',
    formatted: '+7 395 255-53-26',
    raw: '+73952555326',
  },
  {
    phone: '(3952) 55-44-35',
    formatted: '+7 395 255-44-35',
    raw: '+73952554435',
  },
  {
    phone: '(3952) 499-730',
    formatted: '+7 395 249-97-30',
    raw: '+73952499730',
  },
  {
    phone: '(3952) 38-60-09',
    formatted: '+7 395 238-60-09',
    raw: '+73952386009',
  },
  {
    phone: '(3952) 280-444',
    formatted: '+7 395 228-04-44',
    raw: '+73952280444',
  },
  {
    phone: '(3952) 23-45-55',
    formatted: '+7 395 223-45-55',
    raw: '+73952234555',
  },
  {
    phone: '(3952) 20-67-61',
    formatted: '+7 395 220-67-61',
    raw: '+73952206761',
  },
  {
    phone: '(395) 2-707-008, (395) 2-707-009',
    formatted: '+7 395 270-70-09',
    raw: '+73952707009',
  },
  {
    phone: '(39436) 2-11-33',
    formatted: '+7 394 362-11-33',
    raw: '+73943621133',
  },
  {
    phone: '(391) 280-13-08',
    formatted: '+7 391 280-13-08',
    raw: '+73912801308',
  },
  {
    phone: '(391) 248-02-86',
    formatted: '+7 391 248-02-86',
    raw: '+73912480286',
  },
  {
    phone: '(391) 240-82-80',
    formatted: '+7 391 240-82-80',
    raw: '+73912408280',
  },
  {
    phone: '(391) 228-06-26',
    formatted: '+7 391 228-06-26',
    raw: '+73912280626',
  },
  {
    phone: '(391) 200-80-04',
    formatted: '+7 391 200-80-04',
    raw: '+73912008004',
  },
  {
    phone: '(3854) 43-54-78',
    formatted: '+7 385 443-54-78',
    raw: '+73854435478',
  },
  {
    phone: '(3854) 41-76-66',
    formatted: '+7 385 441-76-66',
    raw: '+73854417666',
  },
  {
    phone: '(3852) 72-34-53',
    formatted: '+7 385 272-34-53',
    raw: '+73852723453',
  },
  {
    phone: '(3852) 61-62-23',
    formatted: '+7 385 261-62-23',
    raw: '+73852616223',
  },
  {
    phone: '(38452) 3-11-23',
    formatted: '+7 384 523-11-23',
    raw: '+73845231123',
  },
  {
    phone: '(38445) 3-23-76',
    formatted: '+7 384 453-23-76',
    raw: '+73844532376',
  },
  {
    phone: '(3843) 36-96-04',
    formatted: '+7 384 336-96-04',
    raw: '+73843369604',
  },
  {
    phone: '(3842) 90-30-38, (3842) 90-30-39',
    formatted: '+7 384 290-30-39',
    raw: '+73842903039',
  },
  {
    phone: '(3842) 35-34-47',
    formatted: '+7 384 235-34-47',
    raw: '+73842353447',
  },
  {
    phone: '(3842) 33-55-38',
    formatted: '+7 384 233-55-38',
    raw: '+73842335538',
  },
  {
    phone: '(3842) 33-02-03',
    formatted: '+7 384 233-02-03',
    raw: '+73842330203',
  },
  {
    phone: '(384) 258-03-03',
    formatted: '+7 384 258-03-03',
    raw: '+73842580303',
  },
  {
    phone: '(38362) 51-607',
    formatted: '+7 383 625-16-07',
    raw: '+73836251607',
  },
  {
    phone: '(38353) 21-701',
    formatted: '+7 383 532-17-01',
    raw: '+73835321701',
  },
  {
    phone: '(38341) 5-37-60',
    formatted: '+7 383 415-37-60',
    raw: '+73834153760',
  },
  {
    phone: '(383) 383-27-48',
    formatted: '+7 383 383-27-48',
    raw: '+73833832748',
  },
  {
    phone: '(383) 382-99-98',
    formatted: '+7 383 382-99-98',
    raw: '+73833829998',
  },
  {
    phone: '(383) 363-22-44',
    formatted: '+7 383 363-22-44',
    raw: '+73833632244',
  },
  {
    phone: '(383) 314-41-45',
    formatted: '+7 383 314-41-45',
    raw: '+73833144145',
  },
  {
    phone: '(383) 291-93-31',
    formatted: '+7 383 291-93-31',
    raw: '+73832919331',
  },
  {
    phone: '(383) 271-31-54',
    formatted: '+7 383 271-31-54',
    raw: '+73832713154',
  },
  {
    phone: '(383) 266-17-30, (383) 266-19-11',
    formatted: '+7 383 266-19-11',
    raw: '+73832661911',
  },
  {
    phone: '(383) 254-02-34',
    formatted: '+7 383 254-02-34',
    raw: '+73832540234',
  },
  {
    phone: '(383) 219-89-99',
    formatted: '+7 383 219-89-99',
    raw: '+73832198999',
  },
  {
    phone: '(383) 209-31-39, (963) 945-07-35',
    formatted: '+7 963 945-07-35',
    raw: '+79639450735',
  },
  {
    phone: '(3822) 940-290, 400-290',
    formatted: '+7 382 294-02-90',
    raw: '+73822940290',
  },
  {
    phone: '(3822) 777-444',
    formatted: '+7 382 277-74-44',
    raw: '+73822777444',
  },
  {
    phone: '(3822) 469-537',
    formatted: '+7 382 246-95-37',
    raw: '+73822469537',
  },
  {
    phone: '(3822) 34-36-50',
    formatted: '+7 382 234-36-50',
    raw: '+73822343650',
  },
  {
    phone: '(3822) 32‒32‒70',
    formatted: '+7 382 232-32-70',
    raw: '+73822323270',
  },
  {
    phone: '(382) 413-23-81',
    formatted: '+7 382 413-23-81',
    raw: '+73824132381',
  },
  {
    phone: '(3812) 73-03-79',
    formatted: '+7 381 273-03-79',
    raw: '+73812730379',
  },
  {
    phone: '(3812) 603-702',
    formatted: '+7 381 260-37-02',
    raw: '+73812603702',
  },
  {
    phone: '(3812) 43-22-00, (3812) 21-05-75',
    formatted: '+7 381 221-05-75',
    raw: '+73812210575',
  },
  {
    phone: '(3812) 38-91-25',
    formatted: '+7 381 238-91-25',
    raw: '+73812389125',
  },
  {
    phone: '(3812) 23−73−27',
    formatted: '+7 381 223-73-27',
    raw: '+73812237327',
  },
  {
    phone: '(3812) 20-76-30',
    formatted: '+7 381 220-76-30',
    raw: '+73812207630',
  },
  {
    phone: '(3652) 373‒434',
    formatted: '+7 365 237-34-34',
    raw: '+73652373434',
  },
  {
    phone: '(3532) 99-21-12',
    formatted: '+7 353 299-21-12',
    raw: '+73532992112',
  },
  {
    phone: '(3532) 40-59-99',
    formatted: '+7 353 240-59-99',
    raw: '+73532405999',
  },
  {
    phone: '(35253) 6-10-98',
    formatted: '+7 352 536-10-98',
    raw: '+73525361098',
  },
  {
    phone: '(3522) 46-20-13',
    formatted: '+7 352 246-20-13',
    raw: '+73522462013',
  },
  {
    phone: '(3519) 35-55-75',
    formatted: '+7 351 935-55-75',
    raw: '+73519355575',
  },
  {
    phone: '(351) 701-40-92',
    formatted: '+7 351 701-40-92',
    raw: '+73517014092',
  },
  {
    phone: '(351) 248-44-20',
    formatted: '+7 351 248-44-20',
    raw: '+73512484420',
  },
  {
    phone: '(351) 237-04-33',
    formatted: '+7 351 237-04-33',
    raw: '+73512370433',
  },
  {
    phone: '(351) 235-03-03',
    formatted: '+7 351 235-03-03',
    raw: '+73512350303',
  },
  {
    phone: '(351) 200-36-26',
    formatted: '+7 351 200-36-26',
    raw: '+73512003626',
  },
  {
    phone: '(34789) 2-09-26',
    formatted: '+7 347 892-09-26',
    raw: '+73478920926',
  },
  {
    phone: '(3478) 37-48-58',
    formatted: '+7 347 837-48-58',
    raw: '+73478374858',
  },
  {
    phone: '(3473) 27-92-97',
    formatted: '+7 347 327-92-97',
    raw: '+73473279297',
  },
  {
    phone: '(347) 293-50-94, (347) 292-92-60, (917) 493-50-94',
    formatted: '+7 917 493-50-94',
    raw: '+79174935094',
  },
  {
    phone: '(347) 273-54-91',
    formatted: '+7 347 273-54-91',
    raw: '+73472735491',
  },
  {
    phone: '(347) 265-30-35',
    formatted: '+7 347 265-30-35',
    raw: '+73472653035',
  },
  {
    phone: '(347) 258-86-59',
    formatted: '+7 347 258-86-59',
    raw: '+73472588659',
  },
  {
    phone: '(347) 248-51-98',
    formatted: '+7 347 248-51-98',
    raw: '+73472485198',
  },
  {
    phone: '(347) 235-11-06',
    formatted: '+7 347 235-11-06',
    raw: '+73472351106',
  },
  {
    phone: '(347) 216-70-30; 299-70-30; 298-70-30',
    formatted: '+7 347 216-70-30',
    raw: '+73472167030',
  },
  {
    phone: '(3466) 47-03-95',
    formatted: '+7 346 647-03-95',
    raw: '+73466470395',
  },
  {
    phone: '(3462) 52-16-58',
    formatted: '+7 346 252-16-58',
    raw: '+73462521658',
  },
  {
    phone: '(3462) 21-07-57',
    formatted: '+7 346 221-07-57',
    raw: '+73462210757',
  },
  {
    phone: '(3452) 69-63-13',
    formatted: '+7 345 269-63-13',
    raw: '+73452696313',
  },
  {
    phone: '(3452) 673-550',
    formatted: '+7 345 267-35-50',
    raw: '+73452673550',
  },
  {
    phone: '(34370) 4-72-00, (952) 134-92-95',
    formatted: '+7 952 134-92-95',
    raw: '+79521349295',
  },
  {
    phone: '(34368) 3‒63‒33,  (922) 152‒33‒33',
    formatted: '+7 922 152-33-33',
    raw: '+79221523333',
  },
  {
    phone: '(34346) 5-79-79',
    formatted: '+7 343 465-79-79',
    raw: '+73434657979',
  },
  {
    phone: '(34345)5-80-12, (922) 103-85-66',
    formatted: '+7 922 103-85-66',
    raw: '+79221038566',
  },
  {
    phone: '(34344) 2-83-10, (34344) 7-58-81',
    formatted: '+7 343 447-58-81',
    raw: '+73434475881',
  },
  {
    phone: '(343) 374-71-35',
    formatted: '+7 343 374-71-35',
    raw: '+73433747135',
  },
  {
    phone: '(343) 366-79-00',
    formatted: '+7 343 366-79-00',
    raw: '+73433667900',
  },
  {
    phone: '(343) 288-79-29',
    formatted: '+7 343 288-79-29',
    raw: '+73432887929',
  },
  {
    phone: '(343) 286-30-14',
    formatted: '+7 343 286-30-14',
    raw: '+73432863014',
  },
  {
    phone: '(343) 267-10-53',
    formatted: '+7 343 267-10-53',
    raw: '+73432671053',
  },
  {
    phone: '(343) 258-95-78',
    formatted: '+7 343 258-95-78',
    raw: '+73432589578',
  },
  {
    phone: '(343) 227-76-76',
    formatted: '+7 343 227-76-76',
    raw: '+73432277676',
  },
  {
    phone: '(343) 2003-703',
    formatted: '+7 343 200-37-03',
    raw: '+73432003703',
  },
  {
    phone: '(34260) 4-17-54',
    formatted: '+7 342 604-17-54',
    raw: '+73426041754',
  },
  {
    phone: '(34240) 2-80-46',
    formatted: '+7 342 402-80-46',
    raw: '+73424028046',
  },
  {
    phone: '(342) 221−99−47',
    formatted: '+7 342 221-99-47',
    raw: '+73422219947',
  },
  {
    phone: '(342) 212-07-01',
    formatted: '+7 342 212-07-01',
    raw: '+73422120701',
  },
  {
    phone: '(342) 207-12-70',
    formatted: '+7 342 207-12-70',
    raw: '+73422071270',
  },
  {
    phone: '(342) 2066-358',
    formatted: '+7 342 206-63-58',
    raw: '+73422066358',
  },
  {
    phone: '(342) 206-35-20',
    formatted: '+7 342 206-35-20',
    raw: '+73422063520',
  },
  {
    phone: '(34139) 2-44-40',
    formatted: '+7 341 392-44-40',
    raw: '+73413924440',
  },
  {
    phone: '(3022) 92-56-21',
    formatted: '+7 302 292-56-21',
    raw: '+73022925621',
  },
  {
    phone: '(3022) 710-702',
    formatted: '+7 302 271-07-02',
    raw: '+73022710702',
  },
  {
    phone: '(3022) 209-000, (924) 811-12-71',
    formatted: '+7 924 811-12-71',
    raw: '+79248111271',
  },
  {
    phone: '(3012) 69-77-70, 30-30-59',
    formatted: '+7 301 269-77-70',
    raw: '+73012697770',
  },
  {
    phone: '(3012) 33-24-72',
    formatted: '+7 301 233-24-72',
    raw: '+73012332472',
  },
]
